import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import styles from "./Gallery.module.css";

const Gallery1 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735587987/Gallery/wisjipevwt63j3yfn6yw.jpg";
const Gallery2 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735587987/Gallery/yk8iyrnoi1lpy5vmlcdm.png";
const Gallery3 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557924/gallery_3_bze121.jpg";
const Gallery4 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735587986/Gallery/ry5hx80grtvpo4wf3ybn.jpg";
const Gallery5 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557926/gallery_5_sm4dbs.jpg";
const Gallery6 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557922/gallery_6_yio3iu.jpg";
const Gallery7 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557929/gallery_7_vfdhzv.jpg";
const Gallery19 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735587988/Gallery/u7btuorxpabs97zmmapd.jpg";
const Gallery9 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557922/gallery_9_kled3h.jpg";
const Gallery10 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557930/gallery_10_mgvfxs.jpg";
const Gallery11 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557927/gallery_11_c7st5r.jpg";
const Gallery12 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557923/gallery_12_lbz42l.jpg";
const Gallery13 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557924/gallery_13_i8yzdd.jpg";
const Gallery14 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557925/gallery_14_cnbowa.jpg";
const Gallery16 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557925/gallery_16_lhvfo9.jpg";
const Gallery18 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557930/gallery_18_cexnpg.jpg";
const Gallery20 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557935/gallery_20_xnztls.jpg";
const Gallery21 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557928/gallery_21_e5uwes.jpg";
const Gallery22 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557930/gallery_22_nqia7j.jpg";
const Gallery23 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557929/gallery_23_m1qpxq.jpg";
const Gallery24 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557931/gallery_24_iuvkfy.jpg";
const Gallery25 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557932/gallery_25_exznfj.jpg";
const Gallery27 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557934/gallery_27_gbv0ef.jpg ";
const Gallery28 =
  "https://res.cloudinary.com/dsbwqmbhy/image/upload/v1735557935/gallery_28_qbpc5h.jpg";

const Gallery = () => {
  const [modalImage, setModalImage] = useState(null); // State for the image to be zoomed

  const images = [
    Gallery1,
    Gallery2,
    Gallery3,
    Gallery4,
    Gallery5,
    Gallery6,
    Gallery7,
    Gallery19,
    Gallery9,
    Gallery10,
    Gallery11,
    Gallery12,
    Gallery13,
    Gallery14,
    Gallery16,
    Gallery18,
    Gallery20,
    Gallery21,
    Gallery22,
    Gallery23,
    Gallery24,
    Gallery25,
    // Gallery26,
    Gallery27,
    Gallery28,
    // Gallery8,
    // Gallery15,
    // Gallery17,
    // Gallery19,
  ];

  const handleImageClick = (image) => {
    setModalImage(image); // Set the clicked image to the modal state
  };

  const closeModal = () => {
    setModalImage(null); // Close the modal
  };

  return (
    <>
      <Navbar />
      <div className="container bg-white text-dark text-center p-5 rounded mt-5">
        <div className="row">
          {images.map((image, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
              <img
                draggable="false"
                src={image}
                alt={`Gallery Image ${index + 1}`}
                loading="lazy"
                className="img-fluid rounded shadow-sm"
                onClick={() => handleImageClick(image)} // Open the modal on click
                style={{ cursor: "pointer" }} // Change cursor to pointer
              />
            </div>
          ))}
        </div>
      </div>

      {/* Modal for zoomed image */}
      {modalImage && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div className={styles.modalContent}>
            <img src={modalImage} alt="Zoomed" className={styles.modalImage} />
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Gallery;
